// Calm defaults for experience_preferences (§3.4/§8.6), mirroring the backend
// default_experience_preferences. Used for pre-auth localStorage hydration before the
// backend (source of truth) is reconciled.
export const DEFAULT_EXPERIENCE_PREFS = {
  enabled: false,
  mode: 'Balanced',
  sound: false,
  reducedMotion: 'system',
  notifications: true,
  celebrationNotifications: false,
  quietMode: false,
  quietHours: null,
  consent: { experience_data: false, accepted_at: null },
};

export const EXPERIENCE_PREFS_STORAGE_KEY = 'tla.experience.prefs';
